<!-- 套包拆包-出仓 -->
<template>
  <div class="warehouseOut" v-loading="dailogLoading">
    <div class="warehouseOut-main">
      <div class="div-table-row table-title">
        <div class="div-table-cell" style="width: 20%">配件名称</div>
        <div class="div-table-cell" style="width: 20%">配件编码</div>
        <div class="div-table-cell flex" style="width: 60%">
          <div class="border-right cell-item" style="width: 30%">仓库</div>
          <div class="border-right cell-item" style="width: 30%">仓位</div>
          <div class="border-right cell-item" style="width: 20%">数量</div>
          <div class="cell-item" style="width: 20%"></div>
        </div>
      </div>
      <div class="table-main">
        <div
          class="div-table-row"
          v-for="(item, index) in dataList"
          :key="item.EntpTempGoodsId"
        >
          <div class="div-table-cell" style="width: 20%">
            {{ item.GoodName }}
          </div>
          <div class="div-table-cell" style="width: 20%">
            {{ item.APCode }}
          </div>
          <div class="div-table-cell" style="width: 60%">
            <div
              class="cell-line"
              v-for="(warehouse, i) in item.GoodsLocationList"
              :key="i.key"
            >
              <div class="border-right cell-item" style="width: 30%">
                <el-select
                  v-model="warehouse.WarehouseName"
                  size="small"
                  @change="warehouseChange($event, index, i)"
                  no-data-text="无存放仓库"
                >
                  <el-option
                    v-for="optionItem in item.WarehouseList"
                    :label="optionItem.WarehouseName"
                    :value="optionItem.WarehouseName"
                    v-bind:key="optionItem.index"
                  >
                  </el-option>
                </el-select>
              </div>
              <div class="border-right cell-item" style="width: 30%">
                <el-select
                  v-model="warehouse.ShelfSpaceId"
                  @change="positionChange($event, index, i)"
                  size="small"
                  no-data-text="无存放仓位"
                >
                  <el-option
                    v-for="optionItem in warehouse.positionList"
                    :label="optionItem.ShelfSpaceCode"
                    :value="optionItem.ShelfSpaceId"
                    v-bind:key="optionItem.index"
                  >
                    <span style="display: inline-block; width: 150px">{{
                      optionItem.ShelfSpaceCode
                    }}</span>
                    <span>库存:{{ optionItem.Count }}</span>
                  </el-option>
                </el-select>
              </div>
              <div class="border-right cell-item" style="width: 20%">
                <el-input
                  size="small"
                  type="number"
                  v-model="warehouse.Count"
                  @blur="checkCount(warehouse.Count, warehouse.CountMax)"
                  :max="warehouse.CountMax"
                  :min="1"
                >
                </el-input>
              </div>
              <div
                class="cell-item ops-ctn"
                style="width: 20%; height: 28px; margin-top: 7px"
              >
                <el-button
                  size="mini"
                  icon="el-icon-minus"
                  @click="delItem(index, i)"
                ></el-button>
              </div>
            </div>
          </div>
          <el-button
            size="mini"
            icon="el-icon-plus"
            class="add-btn"
            @click="addItem(index)"
          ></el-button>
        </div>
      </div>
    </div>
    <div class="dialog-footer">
      <el-button size="small" @click="cancel">取消</el-button>
      <el-button class="btn-primary" size="small" @click="submitData"
        >提交拆包</el-button
      >
    </div>
    <!--    快速存放商品    -->
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      title="快速存放商品"
      :visible.sync="storeVisible"
      width="1000px"
      append-to-body
      :before-close="closeStoreDialog"
    >
      <div v-if="storeVisible">
        <storeGoods
          :APList="goodsWaitInList"
          @closeDialog="closeStoreDialog"
        ></storeGoods>
      </div>
    </el-dialog>    
  </div>
</template>
<script>
import storeGoods from "@/components/business/goods/storeGoodsAfterSetSeparate.vue";
export default {
  name: "",
  props: ["SetId"],
  components: {storeGoods},
  data() {
    let userMsg = this.$util.getLocalStorage("userMsg");
    return {
      dailogLoading: false,
      storeVisible:false,
      formData: {
        SetId: this.SetId,
        UserId: userMsg.EmployeeId,
        DetailList: [
          {
            EntpTempGoodsId: "",
            GoodsLocationList: [
              {
                ShelfSpaceId: "",
                Count: "",
              },
            ],
          },
        ],
      },
      EntpId: userMsg.EntpId,
      dataList: [],
      goodsWaitInList:[],//拆包后待入的商品
    };
  },
  mounted() {
    this.getGoodsSetsWH();
  },
  methods: {
    getGoodsSetsWH() {
      this.dailogLoading = true;
      this.$util
        .axiosGet({
          url: "/api/EntpGoods/GetGoodsSetsWH",
          data: {
            SetId: this.formData.SetId,
            EntpId: this.EntpId,
          },
        })
        .then((res) => {
          let apList = res.data;
          let _data = {
            WarehouseName: "",
            ShelfSpaceCode: "",
            ShelfSpaceId: "",
            Count: 1,
            CountMax: 999,
            positionList: [],
          };
          let _APList = [];
          apList.GoodsLocationList = [{ ..._data }];
          _APList.push(apList);
          this.dataList = _APList;

          this.dailogLoading = false;
        })
        .catch(() => {
          this.dailogLoading = false;
        });
    },
    checkCount(count, max) {
      if (count > max) {
        this.$util.warningMsg("数量不得大于库存数量");
      }
    },
    cancel() {
      this.$emit("closeDialog");
    },
    submitData() {
      let that = this;
      let _data = that.dataList;
      for (let i = 0; i < _data.length; i++) {
        let PV = _data[i].Count;
        for (let j = 0; j < _data[i].GoodsLocationList.length; j++) {
          if (!_data[i].GoodsLocationList[j].ShelfSpaceId) {
            that.$util.warningMsg("请选择仓位");
            return;
          }
          if (
            _data[i].GoodsLocationList[j].Count >
            _data[i].GoodsLocationList[j].CountMax
          ) {
            that.$util.warningMsg("数量不得大于库存数量");
            return;
          }
        }
      }
      that.formData.DetailList = that.dataList;
      that.dailogLoading=true;
      that.$util
        .axiosPost({
          url: "/api/EntpGoods/SeparateEnterpriseGoodsSets",
          data: that.formData,
          hideLoading:true,
        })
        .then((res) => {
          if (res.errcode == 0) {
            that
              .$confirm("拆包成功！但并未存放，是否去存放货物？", "温馨提示", {
                confirmButtonText: "存放货物",
                cancelButtonText: "取消",
                type: "success",
                center: true,
              })
              .then(() => {
                that.goodsWaitInList = res.data;
                that.showStoreDialog();
              })
              .catch(() => {
                that.$store.commit("updateNeedRefresh", true);
                that.$emit("closeDialog",true);
              });
          } else that.$util.errorMsg(res.errmsg);
        }).catch(()=>{that.dailogLoading=false;})
    },
    positionChange(value, index, i) {
      let flag = 0;
      let _data = { ...this.dataList[index] };
      let target = _data.GoodsLocationList[i].positionList
        ? _data.GoodsLocationList[i].positionList
        : [];
      for (let j = 0; j < _data.GoodsLocationList.length; j++) {
        if (_data.GoodsLocationList[j].ShelfSpaceId == value) {
          flag += 1;
          if (flag >= 2) {
            _data.GoodsLocationList[j].ShelfSpaceId = "";
            this.$util.warningMsg("不能选相同仓位");
            return;
          }
        }
      }
      for (let n = 0; n < target.length; n++) {
        if (target[n].ShelfSpaceId == value) {
          _data.GoodsLocationList[i].CountMax = target[n].Count;
        }
      }
      this.$set(this.dataList, index, _data);
    },
    warehouseChange(value, index, i) {
      let _data = { ...this.dataList[index] }; // 灵魂晶石
      let _positionList = _data.WarehouseList; //仓库列表

      _data.GoodsLocationList[i].positionList = [];
      _data.GoodsLocationList[i].ShelfSpaceId = "";

      for (let j = 0; j < _positionList.length; j++) {
        if (_positionList[j].WarehouseName == value) {
          _data.GoodsLocationList[i].positionList =
            _positionList[j].GoodsLocationList;
        }
      }
      _data.GoodsLocationList[i].WarehouseName = value;
      this.$set(this.dataList, index, _data);
    },
    delItem(index, i) {
      let _data = { ...this.dataList[index] };
      if (_data.GoodsLocationList.length != 1) {
        _data.GoodsLocationList.splice(i, 1);
      }
      this.$set(this.dataList, index, _data);
    },
    addItem(index) {
      let _target = this.dataList[index].GoodsLocationList;
      for (let i = 0; i < _target.length; i++) {
        if (!_target[i].ShelfSpaceId) {
          this.$util.warningMsg("请选择仓位");
          return;
        }
        if (!_target[i].Count || !_target[i].Count < 0) {
          this.$util.warningMsg("请填写正确的数量");
          return;
        }
      }
      let _data = { ...this.dataList[index] };
      _data.GoodsLocationList.push({
        WarehouseName: "",
        ShelfSpaceCode: "",
        ShelfSpaceId: "",
        Count: this.dataList[index].Count,
        positionList: [],
      });
      this.$set(this.dataList, index, _data);
    },
    showStoreDialog() {
      this.storeVisible = true;
    },    
    closeStoreDialog() {
      this.storeVisible = false;
      this.$emit("closeDialog",true);
      // // 关闭弹窗
      // setTimeout(() => {
      //   this.needConfirm = false;
      //   this.$store.commit("updateNeedRefresh", true);
      //   window.history.go(-1);
      // }, 2000);
    },    
  },
};
</script>
<style lang="less" scoped>
.add-btn {
  position: absolute;
  right: 10px;
  bottom: 6px;
}
.ops-ctn {
  text-align: left !important;
}
.dialog-footer {
  text-align: right;
  margin-top: 20px;
}
.warehouseOut-main {
  padding-top: 20px;
}
.table-title {
  .cell-item {
    width: 33.33%;
  }
  .div-table-cell {
    text-align: center;
    height: 30px;
    line-height: 30px;
  }
}
.div-table-row {
  position: relative;
  overflow: visible;
}
.table-main {
  .div-table-cell {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }
  .cell-line {
    display: flex;
    width: 100%;
  }
  .cell-item {
    padding: 0 10px;
    width: 33%;
    width: inherit;
    text-align: center;
    height: 40px;
    line-height: 40px;
  }
}
</style>
